import {i18n} from "i18next";

import {CitySlug, validateOfferType} from "../../../../../config/cities";
import {chartsRoutes} from "./charts_routes";
import {mapOfferTypeToValidPath, mapPathnameToOfferType, OfferType} from "./offer_type";

interface IMenuItem {
    name: string;
    path: string;
    secondPath: string;
    icon: string;
}

export const getMenuItems = (
    citySlug: CitySlug | null = CitySlug.WARSZAWA,
    pathname: string,
    i18n: i18n
): IMenuItem[] => {
    const offerType = mapPathnameToOfferType(pathname);
    const validOfferType = validateOfferType(citySlug, offerType);
    const detailedOfferType = offerType === OfferType.HOUSE ? OfferType.FLAT : offerType;

    return [
        {
            name: i18n.t("nav.home"),
            path: mapOfferTypeToValidPath(offerType, chartsRoutes[i18n.language].flats.root, i18n),
            icon: "home",
            secondPath: ""
        },
        {
            name: i18n.t("nav.location_summary"),
            path: mapOfferTypeToValidPath(validOfferType, chartsRoutes[i18n.language].flats.city.locationSummary, i18n),
            icon: "region",
            secondPath: ""
        },
        {
            name: i18n.t("nav.dashboard"),
            path: mapOfferTypeToValidPath(validOfferType, chartsRoutes[i18n.language].flats.city.root, i18n),
            icon: "place",
            secondPath: ""
        },
        {
            name: i18n.t("nav.prices"),
            path: mapOfferTypeToValidPath(detailedOfferType, chartsRoutes[i18n.language].flats.city.prices, i18n),
            secondPath: mapOfferTypeToValidPath(
                detailedOfferType,
                chartsRoutes[i18n.language].properties.city.prices,
                i18n
            ),
            icon: "euro"
        },
        {
            name: i18n.t("nav.offer"),
            path: mapOfferTypeToValidPath(detailedOfferType, chartsRoutes[i18n.language].flats.city.offer, i18n),
            secondPath: mapOfferTypeToValidPath(
                detailedOfferType,
                chartsRoutes[i18n.language].properties.city.offer,
                i18n
            ),
            icon: "home_work"
        },
        {
            name: i18n.t("nav.demand"),
            path: mapOfferTypeToValidPath(detailedOfferType, chartsRoutes[i18n.language].flats.city.demand, i18n),
            secondPath: mapOfferTypeToValidPath(
                detailedOfferType,
                chartsRoutes[i18n.language].properties.city.demand,
                i18n
            ),
            icon: "trending_up"
        },
        {
            name: i18n.t("nav.sold"),
            path: mapOfferTypeToValidPath(detailedOfferType, chartsRoutes[i18n.language].flats.city.sold, i18n),
            secondPath: mapOfferTypeToValidPath(
                detailedOfferType,
                chartsRoutes[i18n.language].properties.city.sold,
                i18n
            ),
            icon: "work_outline"
        },
        {
            name: i18n.t("nav.added"),
            path: mapOfferTypeToValidPath(detailedOfferType, chartsRoutes[i18n.language].flats.city.added, i18n),
            secondPath: mapOfferTypeToValidPath(
                detailedOfferType,
                chartsRoutes[i18n.language].properties.city.added,
                i18n
            ),
            icon: "flag"
        },
        {
            name: i18n.t("nav.fltr_dashboards"),
            path: chartsRoutes[i18n.language].flats.fltr,
            icon: "fltr",
            secondPath: ""
        }
    ];
};
